module.exports = __webpack_public_path__ + "static/hero-7278d638eae1f4f9cd3fa4130474ee54.png";